import { render, staticRenderFns } from "./CellImageItem.vue?vue&type=template&id=517be0a0&scoped=true&"
import script from "./CellImageItem.vue?vue&type=script&lang=js&"
export * from "./CellImageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517be0a0",
  null
  
)

export default component.exports